export enum WebsocketConnectionErrors {
  CurrentlyConnected = 0,
  Unreachable = 1,
  Timeout = 2
}
